import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const intialStepState: number = 2;

export const stepsSlice = createSlice({
  name: "step",
  initialState: intialStepState,
  reducers: {
    changeStep: (state, action: PayloadAction<number>) => {
      return action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeStep } = stepsSlice.actions;

export default stepsSlice.reducer;
